import { CatalogAction } from "../actions";
import { Functions, ApiCaller, Variables } from "../../config";
import info from "../../components/info";
import { put, delay } from "redux-saga/effects";
import { notification } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
export default class CatalogMiddleWare {
  static *GetCategories(action) {
    const { params } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Get(`categories`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.getCategoriesSuccess(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getCategoriesError());
    }
  }

  static *CatalogProduct(action) {
    const { params, isTrue } = action;
    console.log("checkingTrue===>", isTrue);
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    const qureyParams = new URLSearchParams(params).toString();
    const URL = !isTrue
      ? `platform_owner/${companyId}/products?${qureyParams}`
      : `/products?${qureyParams}`;
    try {
      let res = yield ApiCaller.Get(URL, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(
          CatalogAction.getProductSuccess(res.data.data, res.data.meta)
        );
      } else {
        yield put(CatalogAction.getProductError());

        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getProductError());
    }
  }

  static *GetBasemixProduct(action) {
    const { params } = action;
    const qureyParams = new URLSearchParams(params).toString();
    const URL = `basemixes?${qureyParams}`;
    try {
      let res = yield ApiCaller.Get(URL, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(
          CatalogAction.getBasemixProductSuccess(res.data.data, res.data.meta)
        );
      } else {
        yield put(CatalogAction.getBasemixProductError());

        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getBasemixProductError());
    }
  }

  static *GetAdditiveProduct(action) {
    const { params } = action;
    const qureyParams = new URLSearchParams(params).toString();
    const URL = `additives?${qureyParams}`;
    try {
      let res = yield ApiCaller.Get(URL, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(
          CatalogAction.getAdditiveProductSuccess(res.data.data, res.data.meta)
        );
      } else {
        yield put(CatalogAction.getAdditiveProductError());

        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getAdditiveProductError());
    }
  }

  static *GetCategoriesProduct(action) {
    const { params } = action;
    const qureyParams = new URLSearchParams(params).toString();
    const URL = `categories?${qureyParams}`;
    try {
      let res = yield ApiCaller.Get(URL, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(
          CatalogAction.getCategoriesProductSuccess(
            res.data.data,
            res.data.meta
          )
        );
      } else {
        yield put(CatalogAction.getCategoriesProductError());

        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getCategoriesProductError());
    }
  }

  static *ShipingCost(action) {
    const { params, id } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;

    try {
      let res = yield ApiCaller.Put(
        `rmx_companies/${companyId}/shipping_charges/${id}`,
        params,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.updateShipingCostSuccess(res.data.data));
      } else {
        yield put(CatalogAction.updateShipingCostError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.updateShipingCostError());
    }
  }

  static *GetShipingCost(action) {
    const { params } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/shipping_charges`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.getShipingCostSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getShipingCostError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getShipingCostError());
    }
  }

  static *postShipingCost(action) {
    const { payload } = action;
    const userId = JSON.parse(localStorage.getItem("companyInfo"))?.id;
    console.log("checkinguserId==>", userId);
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${userId}/shipping_charges`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.postShippingCostSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getShipingCostError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getShipingCostError());
    }
  }

  static *PostProduct(action) {
    const { payload, cb, isTrue } = action;
    const companyId = !isTrue
      ? JSON.parse(localStorage.getItem("platform_owner"))?.[1]?.platform_owner
          ?.id
      : JSON.parse(localStorage.getItem("companyInfo"))?.id;
    let updatedData = [];
    if (payload) {
      const updatedPayload = payload.map((item) => {
        return {
          basemix_id: item.basemix_id,
          category_id: item.category_id,
          derived_from: item.id,
          product_additive: item.product_additives,
          price: item.price,
          name: item.name,
          sku: item.sku,
          weight: item.weight,
          description: item.description,
        };
      });
      updatedData = updatedPayload;
    }

    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/products`,
        { rmx_product: updatedData },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        cb() && cb();
        yield put(CatalogAction.postProductSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.postProductError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postProductError());
    }
  }

  static *UpdateProduct(action) {
    const { params, id, activestatus, cb } = action;

    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;

    const URL = activestatus
      ? `rmx_companies/${companyId}/products/${id}/${activestatus}`
      : `rmx_companies/${companyId}/products/${id}`;
    try {
      let res = yield ApiCaller.Put(
        URL,
        activestatus
          ? {}
          : {
              price: params.price,
              product_additive: params.rmx_product_additives,
            },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.updateProductSuccess(res.data.data));

        cb() && cb();
        if (activestatus) {
          info("success", "Status Changed Success!");
        } else {
          info("success", "Product detail updated successfully");
        }

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.updateProductError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.updateProductError());
    }
  }

  static *UpdateCustomProduct(action) {
    const { payload, id, cb } = action;
    console.log("payloading===>", payload);
    const formData = new FormData();
    if (payload?.image?.name) {
      for (const key in payload) {
        formData.append(key, payload[key]);
      }
    }

    const URL = `products/${id}`;
    try {
      let res = yield ApiCaller.Put(
        URL,
        payload?.image?.name ? formData : payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        yield put(CatalogAction.updateCustomProductSuccess(res.data.data));

        cb() && cb();
        // if (activestatus) {
        //   info("success", "Status Changed Success!");
        // } else {
        //   info("success", "Product detail updated successfully");
        // }

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.updateCustomProductError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.updateCustomProductError());
    }
  }

  static *CustomProduct(action) {
    const { payload, cb } = action;
    let formData = new FormData();
    payload.product_additive.map((item) => {
      formData.append("product_additive[]", JSON.stringify(item));
    });
    delete payload.product_additive;
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    console.log("formData===>", formData);
    try {
      let res = yield ApiCaller.Post(`products`, formData, {
        "Content-Type": "application/json",
      });
      if (res.status == 201) {
        yield put(CatalogAction.postCustomProductSuccess(res.data.data));
        info("success", "Product added successfully!");

        cb() && cb();
      } else {
        yield put(CatalogAction.postCustomProductError());

        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postCustomProductError());
    }
  }

  static *GetBasemixCategories(action) {
    const { params } = action;

    try {
      let res = yield ApiCaller.Get(`basemix_categories`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.getBasemixCategoriesSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getBasemixCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getBasemixCategoriesError());
    }
  }

  static *GetBasemixes(action) {
    const { params } = action;
    try {
      let res = yield ApiCaller.Get(`basemixes?per_page=10000`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.getBasemixesSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getCategoriesError());
    }
  }

  static *GetAddivites(action) {
    const { params } = action;
    try {
      let res = yield ApiCaller.Get(`additives?per_page=10000`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.getAdditivesSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getAdditivesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getAdditivesError());
    }
  }

  static *GetBasemixesCategories(action) {
    const { params } = action;

    try {
      let res = yield ApiCaller.Get(`categories?per_page=10000`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.getBasemixesCategoriesSuccess(res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.getBasemixesCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.getBasemixesCategoriesError());
    }
  }

  static *PostBasemix(action) {
    const { payload, urlParams, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;

    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/${urlParams}`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        yield put(CatalogAction.getBasemixesReq());
        yield put(CatalogAction.getAdditivesReq());
        if (urlParams === "basemix") {
          info("success", "Basemix added successfully!");
        }
        if (urlParams === "additive") {
          info("success", "Additive added successfully!");
        }
        cb() && cb();
      } else {
        yield put(CatalogAction.postBasemixError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postBasemixError());
    }
  }

  static *GetTemplateReq(action) {
    const { params } = action;
    console.log("params", params);
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/download_template`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.getTemplateSuccess(res.data.data));
        notification.open({
          description:
            "Your request is received. You will be notified over an Email!",
          className: "custom-class",
          style: {
            width: 400,
            backgroundColor: "#2E7D32",
            color: "#fff",
            height: "50%",
            marginTop: "40px",
          },
          icon: <InfoCircleOutlined style={{ color: "#fff" }} />,
        });
        setTimeout(() => {
          notification.open({
            description: "Your File has beeen Created Successfull!",
            className: "custom-class",
            style: {
              width: 300,
              backgroundColor: "#2E7D32",
              color: "#fff",
              height: "50%",
            },
            icon: <InfoCircleOutlined style={{ color: "#fff" }} />,
          });
        }, 1000);
      } else {
        yield put(CatalogAction.getTemplateError());
        info("error", res.data.error.message);
        notification.open({
          description: "Something Went Wrong",
          className: "custom-class",
          style: {
            width: 300,
            backgroundColor: "red",
            color: "#fff",
          },
          icon: <InfoCircleOutlined style={{ color: "#fff" }} />,
        });
      }
    } catch (err) {
      yield put(CatalogAction.getTemplateError());
    }
  }

  static *PostFile(action) {
    const { payload } = action;

    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/products/upload`,
        formData,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(CatalogAction.postFileSuccess(res.data.data));
      } else {
        yield put(CatalogAction.postFileError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postFileError());
    }
  }

  static *PostBasemixes(action) {
    const { payload, cb } = action;
    try {
      let res = yield ApiCaller.Post(`basemixes`, payload, {
        "Content-Type": "application/json",
      });
      if (res.status == 201) {
        // yield put(CatalogAction.postBasemixesSuccess(res.data.data));
        cb() && cb();
        info("success", "Basemix Added Successfully!");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.postBasemixesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postBasemixesError());
    }
  }

  static *postBasemixCategories(action) {
    const { payload, cb } = action;

    try {
      let res = yield ApiCaller.Post(`basemix_categories`, payload, {
        "Content-Type": "application/json",
      });
      if (res.status == 201) {
        yield put(CatalogAction.postBasemixCategoriesSuccess(res.data.data));
        cb() && cb();
        info("success", "Basemix Category Added Successfully!");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.postBasemixCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postBasemixCategoriesError());
    }
  }

  static *updateBasemixCategories(action) {
    const { payload, id, cb } = action;
    console.log("payload===>", payload);
    try {
      let res = yield ApiCaller.Put(`basemixes/${id}`, payload, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.updateBasemixCategoriesSuccess(res.data.data));
        info("success", "Basemix Information Added Successfully!");
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.updateBasemixCategoriesError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.updateBasemixCategoriesError());
    }
  }

  static *postAdditiveCatalog(action) {
    const { payload, cb } = action;

    try {
      let res = yield ApiCaller.Post(`additives`, payload, {
        "Content-Type": "application/json",
      });
      if (res.status == 201) {
        yield put(CatalogAction.postAdditiveCatalogSuccess(res.data.data));
        cb() && cb();
        info("success", "Additive Added Successfully!");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.postAdditiveCatalogError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postAdditiveCatalogError());
    }
  }

  static *updateAdditiveCatalog(action) {
    const { payload, id, cb } = action;
    console.log("payload===>", payload);
    try {
      let res = yield ApiCaller.Put(`additives/${id}`, payload, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.updateAdditiveCatalogSuccess(res.data.data));
        cb() && cb();
        info("success", "Additive Information Added Successfully!");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.updateAdditiveCatalogError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.updateAdditiveCatalogError());
    }
  }

  static *postCategoryCatalog(action) {
    const { payload, cb } = action;

    try {
      let res = yield ApiCaller.Post(`categories`, payload, {
        "Content-Type": "application/json",
      });
      if (res.status == 201) {
        yield put(CatalogAction.postCategoryCatalogSuccess(res.data.data));
        cb() && cb();
        info("success", "Category Added Successfully!");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.postCategoryCatalogError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.postCategoryCatalogError());
    }
  }

  static *updateCategoryCatalog(action) {
    const { payload, id, cb } = action;
    console.log("payload===>", payload);
    try {
      let res = yield ApiCaller.Put(`categories/${id}`, payload, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.updateCategoryCatalogSuccess(res.data.data));
        cb() && cb();
        info("success", "Category Information Added Successfully!");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(CatalogAction.updateCategoryCatalogError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.updateCategoryCatalogError());
    }
  }

  static *deleteCatalogProductMiddleWare(action) {
    const { id, payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Put(`products/${id}/${payload}  `, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(CatalogAction.delteCatalogProductSuccess(res.data.data));
        info("success", "Product Deleted Successfully!");

        cb() && cb();
      } else {
        yield put(CatalogAction.delteCatalogProductError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(CatalogAction.delteCatalogProductError());
    }
  }
}
